<template>
  <div class="container h-full mx-auto w-full">
    <div class="card flex h-full w-full py-20">
      <div
        class="bg-gray-100 w-full h-full flex flex-col px-4 justify-center items-center"
      >
        <div class="flex w-full justify-center items-center pb-8">
          <div class="w-1/3">
            <h3 class="font-bold text-xl text-tm-blue">User Registration</h3>
          </div>
          <div class="w-1/3 flex justify-end">
            <img
              src="@/assets/images/logo-corp.png"
              alt="Logo TM One"
              class="h-16"
            />
          </div>
        </div>
        <div class="w-full flex justify-center items-start">
          <div class="flex flex-col justify-center pr-8 w-1/3">
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">
                  First Name
                </h3>

                <el-input v-model="form.firstName"></el-input>
              </div>
            </div>
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">
                  First Name
                </h3>

                <el-input v-model="form.lastName"></el-input>
              </div>
            </div>
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">
                  Email
                </h3>

                <el-input v-model="form.email" type="email"></el-input>
              </div>
            </div>
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">
                  Organization
                </h3>

                <el-input v-model="form.organization"></el-input>
              </div>
            </div>
          </div>
          <div class="flex flex-col justify-center pl-8 w-1/3">
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">User</h3>

                <el-input v-model="form.user"></el-input>
              </div>
            </div>
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">
                  Password
                </h3>

                <el-input
                  v-model="form.password"
                  type="password"
                  show-password
                ></el-input>
              </div>
            </div>
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">
                  Password Confirmation
                </h3>

                <el-input
                  v-model="form.passwordConfirmation"
                  show-password
                  type="password"
                ></el-input>
              </div>
            </div>
            <div class="flex justify-between py-2">
              <div class="w-full flex flex-col justify-start">
                <h3 class="font-semibold text-gray-900 text-base pb-2">
                  Mobile
                </h3>

                <el-input placeholder="Mobile Phone" v-model="form.mobile">
                </el-input>
              </div>
            </div>
            <div class="flex justify-end items-center py-2">
              <el-button type="primary">Submit</el-button>
              <el-button @click="$router.push({ name: 'login' })"
                >Back</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      select: '',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        organization: '',
        user: '',
        password: '',
        passwordConfirmation: '',
        mobile: ''
      }
    }
  }
}
</script>
